import { render, staticRenderFns } from "./ComponentSectorOnPlan.vue?vue&type=template&id=90830c82&"
import script from "./ComponentSectorOnPlan.vue?vue&type=script&lang=ts&"
export * from "./ComponentSectorOnPlan.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentSectorOnPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports